import { createRemoveFilterTag } from '@/creditflowresearch/ui/common/components/FilterTags';
import type { TFilterPayload } from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilter';
import { groupedConfigs, rangeConfigs, dateConfigs } from './corporateFilterTagConfigs';
import { BOOLEAN_DEFAULTS, EXCLUDE_RESET, REMOVE_SIDE_EFFECTS } from './corporateFilterTagConstants';

const removeCorporateFilterTag = createRemoveFilterTag<TFilterPayload>({
  groupedConfigs,
  rangeConfigs,
  dateConfigs,
  booleanDefaults: BOOLEAN_DEFAULTS,
  excludeReset: EXCLUDE_RESET,
  removeSideEffects: REMOVE_SIDE_EFFECTS,
});

export default removeCorporateFilterTag;
